<template>
  <div style="display: flex; flex-direction: column; width: 100%; height: 100%;">
    <el-form
        ref="form"
        :model="form"
        inline
        label-width="100px"
        style="flex: 1;">
      <el-form-item
          label="货件类型"
          prop="shipmentType"
          label-width="177px"
          :rules="[{ required: true, message: '请选择货件类型', trigger: ['blur', 'change'] }]">
        <gj-select
            v-model="form.shipmentType"
            :options="FbaShipmentEnum.shipmentTypeOption"
            :clearable="false"
            width="220px"
        ></gj-select>
      </el-form-item>
      <el-form-item
          label="承运人"
          prop="carrierName"
          :rules="[{ required: true, message: '请选择承运人', trigger: ['blur', 'change'] }]">
        <gj-select
            v-model="form.carrierName"
            :options="carrierNameOption"
            :loading="carrierNameLoading"
            :clearable="false"
            width="220px"
        ></gj-select>
      </el-form-item>
    </el-form>
    <div style="text-align: center;"> 
        <gj-button
          @click="cancel"
          >取消</gj-button>
          <gj-button
              :loading="temporaryTransportDetailsLoading"
              @click="uploadTransportDetails(true)"
          >暂存</gj-button>
          <gj-button
              :loading="uploadTransportDetailsLoading"
              @click="uploadTransportDetails(false)"
          >上传配送服务</gj-button>
          <gj-button
          @click="previousStep"
        >上一步</gj-button>
        <gj-button
            type="primary"
            :disabled="shipment.fbaTransport === FbaShipmentEnum.fbaTransport.NOT_UPLOADED"
            @click="proxyNextStep"
        >下一步</gj-button>
    </div>
  </div>
</template>

<script>
  import {formMixin, formRuleMixin, formValidatorMixin, responseMixin, stepsMixin} from "../../../../../../../minxins";
  import {isMeaningful} from "../../../../../../../utils/common";
  import {getTransportCarrierNames, uploadTransportDetails} from "../../../../../../../api/logistics";
  import {FbaShipmentEnum} from "../../../../../common/logistics/enum";

  export default {
    name: "app-step-2",
    mixins: [formMixin, stepsMixin, formValidatorMixin, formRuleMixin, responseMixin],
    props: {
      id: {
        required: true
      },
      nextStep: {
        required: true
      },
      shipment: {
        required: true
      },
      mountTo: {
        required: true
      }
    },
    data() {
      return {
        carrierNameOption: [],
        FbaShipmentEnum: FbaShipmentEnum,
        carrierNameLoading: false,
        uploadTransportDetailsLoading: false,
        temporaryTransportDetailsLoading: false
      }
    },
    watch: {
      'form.shipmentType': {
        handler: function(shipmentType) {
          if (isMeaningful(shipmentType)) {
            this.carrierNameLoading = true;
            getTransportCarrierNames({
              countryCode: this.form.countryCode,
              shipmentType: this.form.shipmentType,
            })
              .then((data) => {
                this.carrierNameOption = data;
              })
              .complete(() => this.carrierNameLoading = false);
          } else {
            this.form.shipmentType = FbaShipmentEnum.shipmentType.SPD;
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      proxyNextStep() {
        this.nextStep();
      },
      uploadTransportDetails(isTemporary) {
        if (this.formValidate()) {
          if (!isTemporary && (this.shipment.fbaPackage === FbaShipmentEnum.fbaPackage.UPLOADING
            || this.shipment.fbaPackage === FbaShipmentEnum.fbaPackage.UPLOAD_SUCCESS)) {
            const modal = this.$gjCreate('gj-info-modal', {
              mountTo: this.mountTo,
              props: {
                content: '已经上传过装箱单信息，上传物流信息之后将会清空之前的装箱信息（需要再次上传装箱信息），确认继续上传？'
              },
              on: {
                cancel: () => modal.$gjDestroy(),
                confirm: () => {
                  this._uploadTransportDetails(isTemporary);
                }
              }
            })
          } else {
            this._uploadTransportDetails(isTemporary);
          }
        }
      },
      _uploadTransportDetails(isTemporary) {
        if (isTemporary) {
          this.temporaryTransportDetailsLoading = true
        } else {
          this.uploadTransportDetailsLoading = true;
        }
        uploadTransportDetails({
          id: this.id,
          carrierName: this.form.carrierName,
          shipmentType: this.form.shipmentType,
          isTemporary
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              if (!isTemporary) {
                this.shipment.fbaTransport = FbaShipmentEnum.fbaTransport.UPLOAD_SUCCESS;
              }
              this.$emit('markUpdate');
              this.$gjMessage.success(res.data);
            });
          })
          .complete(() => {
            if (isTemporary) {
              this.temporaryTransportDetailsLoading = false;
            } else {
              this.uploadTransportDetailsLoading = false;
            }
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>
